import { Signal } from "micro-signals";

export class AnnouncementReceivedService {
	onAnnouncementIdReceived = new Signal<string>();
}
